<template>
    <div v-if="countCropPeriods_finish > 0">
        <h4 class="header-sub">
            {{ $t('menu.cropping_season_information') }} ( {{ $t('menu.finished') }} )
            <b-badge class="badge-small block-text">{{ cropperiods.length }}</b-badge>
            <b-btn class="btn-collapse" variant="outline-success" @click="showControlTips = !showControlTips">{{ $t('menu.show') }} / {{ $t('menu.hide') }}</b-btn>
        </h4>
      

        <b-row v-if="showControlTips">
            <template v-for="(cropP,idx) in cropperiods">

                <b-col cols="12" xl="6" :key="idx" v-if="cropP.end_date">
                    <b-card :id="'cropperiod-' + idx">
                        <b-media no-body>
                            <b-media-aside vertical-align="top">
                                <div class="proj-img cover-bg clickable-img" alt="project photo" @click="goToPage('project', projID, cropP.id)"
                                    :style="$tools.style.imgCover( $config.checkURL('cropperiod', cropP.pic) )" />

                            </b-media-aside>
                            <b-media-body class="ml-3">
                                <b-row>
                                    <b-col sm="8" md="8" lg="8">
                                        <h4 class="card-title agri-color clickable" v-text="cropP.name" @click="goToPage('project', projID, cropP.id)"></h4>
                                    </b-col>
                                    <b-col sm="4" md="4" lg="4" class="text-right">
                                        <!-- 未來可放期作狀態 -->
                                    </b-col>
                                </b-row>

                                <!-- 敘述 -->
                                <div class="card-subtitle mb-2">
                                    <div class="block-text">{{ cropP.description }}</div>
                                </div>

                                <!-- 積溫 -->
                                <div class="card-subtitle mb-2" v-if="cropP.whole_percentage">
                                    <div class="progressbar-title">
                                        <i class="wi wi-stars block-text"></i>{{ $t('menu.crop_growth_progress') }}
                                    </div>
                                    <b-progress animated :max="100" class="mb-3 progressbar-bg">
                                        <b-progress-bar class="progressbar-cropperiod" :value="cropP.whole_percentage">
                                            {{ cropP.whole_percentage }} %
                                        </b-progress-bar>
                                        <!-- <b-progress-bar variant="success" :value="10" :label="progress"></b-progress-bar> -->
                                        <!-- <b-progress-bar variant="info" :value="30"></b-progress-bar> -->
                                    </b-progress>
                                </div>

                                <!-- 栽種期間 -->
                                <div class="card-subtitle mb-2" v-if="cropP.end_date">
                                    <i class="fa fa-calendar block-text"></i>
                                    <div class="block-text">{{ $t('menu.planting_period') }}:</div>
                                    <div class="block-text">{{ cropP.start_date }} -- {{ cropP.end_date }}</div>
                                    <div class="block-text">( {{ $tools.date.countDays(cropP.start_date, cropP.end_date) }}
                                        {{ $t('u.days') }} )</div>

                                </div>
                                <!-- 開始日期 -->
                                <div class="card-subtitle mb-2" v-else>
                                    <i class="fa fa-calendar block-text"></i>
                                    <div class="block-text">{{ $t('menu.planting_day') }}:</div>
                                    <div class="block-text">{{ cropP.start_date }}</div>
                                    <div class="block-text">( {{ $tools.date.countDays(cropP.start_date) }} {{
                                        $t('u.days_ago') }} )</div>
                                </div>

                                <!-- 田區 -->
                                <div class="card-subtitle mb-2">
                                    <i class="cui-dashboard block-text"></i>
                                    <div class="block-text">{{ $t('n.field') }}:</div>
                                    <div class="block-text">{{ cropP.farm_field }}</div>
                                </div>



                            </b-media-body>
                        </b-media>


                        <!-- 逆境預警偵測 -->
                        <!-- <div class="stress-group">
                            <StressAlertList :queryHours="24" :timezone="timezone" :showType="'icon_text'" :project_id="projID"
                                :cropperiod_id="cropP.id" :linkToDashboard="true"></StressAlertList>
                        </div> -->

                        <!-- 底部按鈕 -->
                        <div class="cp-link-group text-right">
                            <!-- <div class="cp-link-btn">
                                <b-button class="btn-cp" :to="$config.getPagesURL('report', projID, cropP.id)">
                                    <i class="icon-book-open"></i>{{ $t('menu.agri_science_reports') }}
                                </b-button>
                            </div> -->
                            <!-- <div class="cp-link-btn">
                                <b-button class="btn-cp" :to="$config.getPagesURL('project', { projectID: projID, cropperiodID: cropP.id })">
                                    <i class="fa fa-dashboard"></i>{{ $t('menu.agri_dashboard') }}
                                </b-button>
                            </div> -->

                            <div class="cp-link-btn">
                                <b-button class="btn-cp" @click="goToPage('history', projID, cropP.id)">
                                    <i class="fa fa-dashboard"></i>{{ $t('menu.history') }}
                                </b-button>
                            </div>
                        </div>

                  </b-card>
              </b-col>
          </template>

      </b-row>
      <!--/.row-->

    </div>
</template>


<script>
    // import TestData from '@/testData/testData'
    import { mapState } from 'vuex'
    import StressAlertList from '@/views/components/StressAlertList'
    import NoData from '@/views/components/NoData'


    export default {
        name: 'cropPeriods',
        // props: ['cropperiods'],
        components: {
            StressAlertList,
            NoData,
        },
        data() {
            return {
                showControlTips: true,
                // cropperiods: TestData.cropperiods,
            }
        },
        computed: {
            ...mapState({
                'user_admin': state => state.user.is_admin,
                'project_detail': state => state.project.project_detail,
                'cp_alerts_data': state => state.cropperiod.alerts_data,
            }),

            projID() {
                return this.$route.params.projectID;
            },
            projectActive () {
                if (this.project_detail)
                {
                    return this.$tools.service.check_ShowUI_ProjectEnd( this.project_detail.status, this.user_admin )
                }
                return false
            },
            cropperiods() {
                return this.project_detail.done_cropperiods;
            },
            timezone() {
                return this.project_detail.timezone;
            },
            
            countCropPeriods_finish ()
            {
                let _count = 0;
                this.cropperiods.forEach( _cp => {
                    if ( _cp.end_date ) _count++;
                })
                return _count;
            },

        },
        methods: {

            goToPage: function (type, pID, cpID = undefined)
            {
                if (this.projectActive)
                {
                    this.$router.push(this.$config.getPagesURL(type, { projectID: pID, cropperiodID: cpID }));
                }
                else
                {
                    let _history_url = this.$config.getPagesURL('history', { projectID: pID })
                    _history_url.query = { cropperiod: cpID }

                    this.$router.push(_history_url);
                }
            },

        }
    }

</script>

<style lang="scss" scoped>
    .stress-group {
        margin-right: 5px;
    }

    .cp-link-group {
        float: right;
        //display: inline-block;
    }

    .cp-link-btn {
        display: inline-block;
        margin-left: 5px;
    }

</style>
